var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('x-page',{attrs:{"title":"确认收货"}},[_c('x-result',{attrs:{"title":"确认收货成功","confirm-text":"立即评价","guess-resource-position-id":"8aaa8b7b79f3a40d017a0f0700820108","confirm-track":{
      name: '确认收货-立即评价',
      id: '09693ad2-07dd-48a8-86e4-2cb940d90a0c',
    }},on:{"confirm":_vm.handleConfirmClick}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }